import { saveBinaryContent, saveTextContent } from '@paragon/client-tools';
import { DigitalQCOutputFormat, PlateManufacturer } from '@paragon/contract-library';

import { DesignService } from '../connections';

interface QualityControlDiagramsResponse {
  readonly pdfBase64: string;
  readonly erroredPlatePairNames: string[];
}

export async function downloadQualityControlDiagrams(
  fileName: string,
  analysisSetGuid: string,
  jsiMinimum: number | null,
  platePairGuids: string[] | null,
  projectName: string,
  forceQCReanalysis: boolean,
  sharedComponentSetLookupCode?: string,
): Promise<string[]> {
  const qualityControlDiagramsResponse = await DesignService.post<QualityControlDiagramsResponse>(
    'qualityControl/qualityControlDiagrams',
    {
      data: { projectName, analysisSetGuid, jsiMinimum, platePairGuids, forceQCReanalysis },
      params: sharedComponentSetLookupCode ? new URLSearchParams({ sharedComponentSetLookupCode }) : undefined,
    },
  );

  const pdfByteCharacters = await window.fetch(qualityControlDiagramsResponse.pdfBase64);
  const pdfBlob = await pdfByteCharacters.blob();
  saveBinaryContent(fileName, pdfBlob);

  return qualityControlDiagramsResponse.erroredPlatePairNames;
}

interface QualityControlFileResponse {
  readonly dataJson: string;
  readonly erroredPlatePairNames: string[];
}

export async function downloadDigitalQcFile(
  fileName: string,
  analysisSetGuid: string,
  projectName: string,
  digitalQCOutputFormat: DigitalQCOutputFormat,
  forceQCReanalysis: boolean,
  tangiblePlateTypeMap: { [platePairGuid: string]: PlateManufacturer },
  sharedComponentSetLookupCode?: string,
): Promise<string[]> {
  const digitalQcFileResponse = await DesignService.post<QualityControlFileResponse>('qualityControl/digitalQcFile', {
    data: { projectName, analysisSetGuid, digitalQCOutputFormat, forceQCReanalysis, tangiblePlateTypeMap },
    params: sharedComponentSetLookupCode ? new URLSearchParams({ sharedComponentSetLookupCode }) : undefined,
  });
  saveTextContent(fileName, digitalQcFileResponse.dataJson);
  return digitalQcFileResponse.erroredPlatePairNames;
}
